import React from 'react';
import { CheckIcon } from 'lucide-react';
import { AccordionItem } from './Accordion';
import { MODULES } from '../data/content';
export function Modules() {
  return <section className="px-5 py-8" data-id="element-111">
      <div className="mx-auto max-w-xl" data-id="element-112">
        <p className="text-center text-sm font-700 uppercase tracking-widest text-[var(--pb-lime)]" data-id="element-113">
          What's Inside
        </p>
        <h2 className="mt-2 text-center font-display text-3xl font-800 uppercase leading-tight text-white" data-id="element-114">
          7 Step-by-Step Modules
        </h2>

        <div className="mt-6 space-y-3" data-id="element-115">
          {MODULES.map((m, i) => <AccordionItem key={m.title} emoji={m.emoji} title={m.title} defaultOpen={i === 0} data-id="element-116">
              <ul className="space-y-2 pl-1" data-id="element-117">
                {m.items.map(item => <li key={item} className="flex items-start gap-2 text-sm leading-relaxed text-white/80" data-id="element-118">
                    <CheckIcon size={16} className="mt-0.5 shrink-0 text-[var(--pb-lime)]" data-id="element-119" />
                    <span data-id="element-120">{item}</span>
                  </li>)}
              </ul>
            </AccordionItem>)}
        </div>
      </div>
    </section>;
}